<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 210 297"
  >
    <path
      transform="scale(0.26458333)"
      d="m 444.44531,146.75781 c 3.75874,0.26629 5.5564,4.65441 7.625,15.25391 2.65096,13.58417 3.54973,29.90319 3.31446,60.16797 -0.19125,24.65675 -0.0374,29.08074 1.16015,31.9082 1.82207,4.32863 3.79967,5.38752 7.25,3.88086 3.06308,-1.33762 3.81311,-2.34395 4.55469,-6.10937 0.28989,-1.47414 1.61549,-3.52187 2.94531,-4.55079 2.23385,-1.7291 3.50451,-1.86602 16.77735,-1.8125 16.16246,0.0649 24.95959,1.43247 49.49609,7.69336 13.0676,3.33445 14.80002,3.58653 17.92773,2.61328 7.27593,-2.264 12.42902,-9.16284 25.78711,-34.51757 14.16212,-26.88103 21.8298,-45.51341 23.29297,-56.60743 1.38898,-10.53189 3.55666,-12.72973 9.43945,-9.57031 6.63319,3.56247 15.71934,20.74219 19.75977,37.35742 6.6985,27.54593 5.55414,42.80432 -5.38672,71.75977 -7.09867,18.7872 -9.43028,28.30876 -10.91601,44.59375 -1.59213,17.45648 1.68574,39.40571 8.57812,57.43164 6.0745,15.88641 12.69064,27.61634 31.50195,55.86328 7.74565,11.63055 8.20547,21.35086 2.07618,43.83399 -7.27355,26.68006 -9.35309,40.52582 -10.08008,67.09961 -1.24143,45.37655 6.45494,95.48433 21.0664,137.14648 1.75677,5.00901 10.21171,23.59828 18.78711,41.31055 18.4783,38.16657 21.87784,47.54126 22.55664,62.1875 0.55015,11.85486 -1.42528,20.70534 -7.48046,33.53125 -14.78393,31.31312 -33.30292,53.9353 -52.20313,63.77148 -10.64818,5.54139 -16.75647,6.90641 -30.54687,6.82617 -14.12674,-0.0899 -19.65069,-1.28274 -34.74805,-7.55664 -11.63119,-4.83371 -19.49017,-9.78738 -25.60352,-16.13672 -7.61261,-7.90616 -11.29063,-16.76784 -20.20703,-48.69336 -15.72514,-56.30517 -18.01038,-62.51484 -27.49609,-74.71289 -15.7352,-20.2351 -47.1958,-36.10191 -92.20899,-46.50586 -15.88785,-3.67226 -25.22558,-4.82778 -29.45703,-3.64453 -2.93586,0.8205 -3.9063,1.78638 -6.79492,6.76953 -4.51544,7.78953 -20.53914,28.43708 -46.86914,60.39454 -37.33757,45.31755 -69.70176,88.44814 -89.2793,118.97656 -3.31294,5.16597 -12.56781,20.96607 -20.5664,35.11133 l -14.54297,25.71875 -31.04492,-0.10743 c -17.07507,-0.0567 -33.5651,-0.45015 -36.64454,-0.86132 l -0.002,-0.006 C 129.19486,924.28482 123.66605,917.06186 112.55469,882.5293 85.282573,797.77014 77.893055,647.70656 96.304688,552.52539 c 6.133862,-31.71042 17.097342,-65.95959 28.933592,-90.39258 10.2474,-21.15269 19.17205,-33.84213 36.00977,-51.20312 31.40007,-32.37578 70.37639,-55.9935 166.75976,-101.04102 34.94793,-16.33386 49.0146,-23.87781 54.85742,-29.42383 7.06103,-6.70221 8.05044,-9.37193 8.97461,-24.20312 1.26229,-20.26214 4.87298,-36.62008 12.52539,-56.75391 10.47364,-27.55761 21.8913,-44.84039 33.5293,-50.7539 2.7286,-1.38645 4.84227,-2.11714 6.55078,-1.9961 z"
    />
  </svg>
</template>

<script>
export default {
  props: ['size'],
  setup() { }
}
</script>

<style lang="scss" scoped>
@import '../styles/variables/colors';

@keyframes color-shift {
  0%, 100% {
    animation-timing-function: cubic-bezier(0.25, 0, 1, 0.25);
  }
  0% {
    fill-opacity: 1;
  }
  50% {
    fill-opacity: 0.6;
    animation-timing-function: cubic-bezier(0, 0.25, 0.25, 1);
  }
  100% {
    fill-opacity: 1;
  }
}

svg {
  height: 60px;
  width: 60px;
  fill: $pink;
  fill-opacity: 1;
  animation: color-shift;
  animation-duration: 3s;
  animation-iteration-count: infinite;
}

</style>
